import { useTranslation } from 'react-i18next';
import { SlidersHorizontal } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { ThemeSwitcher } from '@/components/ThemeSwitcher';
import { FontSwitcher } from '@/components/FontSwitcher';
import { TimeFormatSwitcher } from '@/components/TimeFormatSwitcher';
import { MealThumbnailSizeSwitcher } from '@/components/MealThumbnailSizeSwitcher';
import { ServingSizeToggle } from '@/components/ServingSizeToggle';
import { TagPlacementSwitcher } from '@/components/TagPlacementSwitcher';
import { SummaryStatsToggle } from '@/components/SummaryStatsToggle';
import { NutrientTimingPrefs } from '@/components/NutrientTimingPrefs';
import { SummaryLayoutPrefs } from '@/components/SummaryLayoutPrefs';

/**
 * Bundles the per-device display/format preferences (theme, font, meal-photo
 * size, summary stats, nutrient timing, summary layout) into one compact card.
 * Each control renders in its `section` variant so they read as a tidy list
 * instead of stacked cards. Lives at the bottom of the Profile page.
 */
export const DisplayPreferencesCard = () => {
  const { t } = useTranslation();

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2 text-base">
          <SlidersHorizontal className="h-4 w-4 text-primary" />
          {t('Display preferences')}
        </CardTitle>
      </CardHeader>
      <CardContent className="divide-y">
        <div className="pb-5">
          <ThemeSwitcher variant="section" />
        </div>
        <div className="py-5">
          <FontSwitcher variant="section" />
        </div>
        <div className="py-5">
          <TimeFormatSwitcher variant="section" />
        </div>
        <div className="py-5">
          <MealThumbnailSizeSwitcher variant="section" />
        </div>
        <div className="py-5">
          <ServingSizeToggle variant="section" />
        </div>
        <div className="py-5">
          <TagPlacementSwitcher variant="section" />
        </div>
        <div className="py-5">
          <SummaryStatsToggle variant="section" />
        </div>
        <div className="py-5">
          <NutrientTimingPrefs variant="section" />
        </div>
        <div className="pt-5">
          <SummaryLayoutPrefs variant="section" />
        </div>
      </CardContent>
    </Card>
  );
};
